module.exports = __webpack_public_path__ + "media/Loops 110 Strings.46f4c529.wav";